import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowCircleBrokenLeft = function ArrowCircleBrokenLeft(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20.6621 17c-1.7291 2.989-4.9608 5-8.6622 5-5.5229 0-10-4.4772-10-10s4.4771-10 10-10c3.7014 0 6.9331 2.011 8.6622 5m-8.6622 1-4 4m0 0 4 4m-4-4h14"
    })
  }));
};
export default ArrowCircleBrokenLeft;